import type { FunctionComponent } from "preact";
import * as stylex from "@stylexjs/stylex";

const styles = stylex.create({
    container: {
        marginBottom: "20px",
    },
    title: {
        padding: "5px 8px",
        paddingLeft: "12px",
        marginBottom: "8px",
        backgroundColor: "#F0F0F0",
        fontFamily: "'Inter Variable', sans-serif",
        fontWeight: 550,
        fontSize: "12px",
        color: "#888",
    },
    content: {
        padding: "0 10px",
    },
});

const Separator: FunctionComponent<{ label: string }> = ({ label, children }) => {
    return (
        <div {...stylex.props(styles.container)}>
            <div {...stylex.props(styles.title)}>{label}</div>
            <div {...stylex.props(styles.content)}>{children}</div>
        </div>
    );
};

export default Separator;
